import { useRef, useState } from 'react';
import type FundOpportunity from '../../../models/FundOpportunity';
import type BackendService from '../../../services/admin/BackendService';
import { errText } from './videoLibraryErrorText';

/**
 * Investor-facing static PDF upload:
 * upload to `staticPDFs/FundOpportunity/{id}/static.pdf`, then refresh Gemini.
 */
export function useStaticPdfUpload(
  fundOpportunity: FundOpportunity | null,
  backendService: BackendService,
) {
  const inputRef = useRef<HTMLInputElement>(null);
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const openPicker = () => inputRef.current?.click();

  const onFileSelected = async (file: File | undefined) => {
    if (!file || !fundOpportunity) return;
    setUploading(true);
    setError(null);
    try {
      await backendService.uploadAssetContent(
        'staticPDFs',
        fundOpportunity.id,
        'FundOpportunity',
        'static.pdf',
        file,
        'pdf',
      );
      await backendService.triggerDocumentUpdated(fundOpportunity, { pdf: true });
    } catch (err) {
      setError(errText(err));
    } finally {
      setUploading(false);
      if (inputRef.current) inputRef.current.value = '';
    }
  };

  return { inputRef, openPicker, onFileSelected, uploading, error };
}
